"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignifydCreateOrderFulfillmentSchema = void 0;
exports.SignifydCreateOrderFulfillmentSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        recordId: {
            type: 'string',
            minLength: 1,
        },
        trackingNum: {
            type: 'string',
            minLength: 1,
        },
        trackingUrl: {
            type: 'string',
            minLength: 1,
        },
        orderType: {
            type: 'string',
            minLength: 1,
        },
        sObjectName: {
            type: 'string',
            minLength: 1,
        },
        environmentId: {
            type: 'string',
            minLength: 1,
        },
        messageId: {
            type: 'string',
            minLength: 1,
        },
        salesChannelName: {
            type: 'string',
            minLength: 1,
        },
    },
    required: [
        'recordId',
        'trackingNum',
        'trackingUrl',
        'orderNumber',
        'messageId',
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,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